<template>
  <div class="case-page">
    <div class="case-page__header page-section page-section--soft">
      <div class="section-container">
        <section v-reveal>
          <span class="section-label">Cases</span>
          <h1 class="section-title">来自真实跨境企业的数字化实践</h1>
          <p class="section-subtitle section-subtitle--center">
            精选客户案例，见证跨境业务增长与协同效率提升
          </p>
        </section>
      </div>
    </div>

    <a-carousel class="case-carousel" autoplay :autoplay-speed="4200" dots>
      <div v-for="item in caseBanners" :key="item.id" class="slide-item">
        <section class="case-hero">
          <div class="case-hero__bg">
            <img class="case-hero__bg-img" :src="item.image" alt="" aria-hidden="true" />
            <div class="case-hero__overlay"></div>
          </div>
          <div class="section-container case-hero__content">
            <article class="case-card" v-reveal>
              <p class="case-card__tag">企业案例</p>
              <h2 class="case-card__title">{{ item.name }}</h2>
              <p class="case-card__desc" v-html="item.intro"></p>
            </article>
          </div>
        </section>
      </div>
    </a-carousel>

    <section class="case-list-section page-section page-section--soft">
      <div class="section-container">
        <h2 v-reveal class="case-list__title">合作客户案例</h2>
        <div class="case-list-grid">
          <article
            v-for="(item, index) in caseList"
            :key="item.id"
            v-reveal
            class="case-list-card"
            :class="'reveal--delay-' + (index % 4 + 1)"
          >
            <div class="case-list-card__media">
              <img
                class="case-list-card__cover"
                :src="item.image"
                :alt="item.brand"
                loading="lazy"
                decoding="async"
              />
              <span v-if="item.stockCode" class="case-list-card__stock">
                股票代码: {{ item.stockCode }}
              </span>
            </div>
            <div class="case-list-card__body">
              <div class="case-list-card__brand">
                <img
                  v-if="item.logo"
                  class="case-list-card__logo"
                  :src="item.logo"
                  :alt="item.brand"
                  loading="lazy"
                />
                <span v-else class="case-list-card__name">{{ item.brand }}</span>
              </div>
              <p class="case-list-card__headline">{{ item.headline }}</p>
              <div class="case-list-card__footer">
                <span class="case-list-card__tag">{{ item.category }}</span>
                <a
                  v-if="item.website"
                  :href="item.website"
                  class="case-list-card__link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  查看详情 &gt;
                </a>
                <a
                  v-else-if="item.linkable !== false"
                  href="#"
                  class="case-list-card__link"
                  @click.prevent="openDemoModal"
                >
                  查看详情 &gt;
                </a>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>

    <demo-register-modal :visible="demoModalVisible" @update:visible="demoModalVisible = $event" />
  </div>
</template>

<script>
import DemoRegisterModal from "../components/DemoRegisterModal.vue";

const caseBanners = [
  {
    id: "case-1",
    name: "海仓国际",
    image: require("@/static/cases/seacang.png"),
    intro:
      "海仓国际（seacang）电子商务有限公司为东南亚电商提供标准化的仓配、头程、尾程以及定制化的正逆向一体化供应链式的服务及解决方案。公司的运作形式属于第三方物流服务，总部坐落于跨境电商圈：深圳，分公司位于泰国曼谷。现国内集货仓位于深圳，海外仓覆盖整个东南亚，包括：泰国、越南、菲律宾、新加坡、马来西亚、印度尼西亚，目前海外仓面积超12000平。完善的公司运作体系、强大的海外仓储管理制度（包括自主开发的ERP系统）、以及极具竞争优势的本土派送和售后服务共同组成了海仓国际的核心竞争力。海仓国际自成立以来，一直秉持着诚信、创新、发展、卓越、共赢的企业价值观，坚持以人为本，客户至上；以诚为本，行动力至上。以提升公司运转效率和客户满意度为首要宗旨，一直致力于成为高效、精准、敏捷及第三方仓储物流服务为一体的完整供应链式的电商零售仓配服务标杆企业。总之，海沧国际努力做客户满意、员工欢迎、社会尊敬的行业领跑者，助力跨境卖家远帆出海！"
  },
  {
    id: "case-2",
    name: "闪衣供应链",
    image: require("@/static/cases/shiney.png"),
    intro:
      "闪衣服装仓（ShineY）是由一个资深团队倾力孵化打造，团队成员均为多年从事服装出海履约的业内专家，专注于为服装跨境电商提供定制化的正逆向一体化供应链服务及多样化增值服务解决方案。<br> 强大的仓储实力：拥有超过100,000㎡ 海外物流园区，员工超 700人。<br> 前置仓整合（国内）：广东、福建、浙江（承担备货整合、分类管理与标准化前置处理）。<br> 海外仓覆盖（本地）：越南、泰国、马来西亚、菲律宾、印度尼西亚（提供本地存储、分拣及高附加值增值服务）。"
  },
  {
    id: "case-3",
    name: "泰鑫商贸有限公司",
    image: require("@/static/cases/taixin.png"),
    intro:
      "泰鑫商贸有限公司是一家深耕中泰跨境物流领域，专注打造泰国海外仓储+跨境头程物流一体化服务的专业物流商贸企业，立足国内、扎根泰国，专注服务跨境电商、外贸企业、实体商户等出海客户，助力国货高效布局泰国市场。"
  },
  {
    id: "case-4",
    name: "路遥管理系统",
    image: require("@/static/cases/luyao.png"),
    intro:
      "路遥管理系统是我们为一家物流公司量身定制的数字化管理平台，覆盖订单、仓储、运输等核心业务场景，助力物流企业提升运营效率与服务能力。"
  }
];

const caseList = [
  {
    id: "list-1",
    brand: "海仓国际",
    image: require("@/static/cases/seacang.png"),
    logo: require("@/static/seacang-logo.png"),
    headline: "东南亚仓配企业「海仓国际」借助数字化系统加速出海履约",
    category: "跨境仓储类",
    website: "https://seacang.com/"
  },
  {
    id: "list-2",
    brand: "闪衣供应链",
    image: require("@/static/cases/shiney.png"),
    logo: require("@/static/shanyi-logo.png"),
    headline: "服装供应链「闪衣」借助 ERP 实现正逆向一体化履约",
    category: "服装供应链",
    website: "https://www.shiney.cn/"
  },
  {
    id: "list-3",
    brand: "泰鑫商贸有限公司",
    image: require("@/static/cases/taixin.png"),
    logo: require("@/static/taixin-logo.png"),
    headline: "中泰跨境物流「泰鑫商贸」打造泰国海外仓+头程一体化服务",
    category: "跨境物流类",
    linkable: false
  },
  {
    id: "list-4",
    brand: "路遥管理系统",
    image: require("@/static/cases/luyao.png"),
    headline: "物流公司借助「路遥管理系统」实现订单、仓配、运输一体化管理",
    category: "物流类",
    website: "https://luyao.seacang.com/"
  }
];

export default {
  components: {
    DemoRegisterModal
  },
  data() {
    return {
      caseBanners,
      caseList,
      demoModalVisible: false
    };
  },
  methods: {
    openDemoModal() {
      this.demoModalVisible = true;
    }
  }
};
</script>

<style scoped>
.case-page__header {
  padding-bottom: 48px;
}

.case-page__header .section-subtitle {
  margin-bottom: 0;
}

.section-subtitle--center {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.case-carousel /deep/ .slick-slide > div {
  height: 100%;
}

.slide-item {
  height: 100%;
}

.case-hero {
  position: relative;
  min-height: 680px;
  display: flex;
  align-items: center;
  padding: 80px 0 96px;
  overflow: hidden;
}

.case-hero__bg {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.case-hero__bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 40%;
  transform: scale(1.02);
}

.case-hero__overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(
      to left,
      rgba(255, 255, 255, 0.97) 0%,
      rgba(255, 255, 255, 0.88) 38%,
      rgba(246, 249, 255, 0.55) 68%,
      rgba(22, 119, 255, 0.08) 100%
    ),
    linear-gradient(
      to bottom,
      rgba(248, 250, 252, 0.2) 0%,
      transparent 45%,
      rgba(10, 39, 93, 0.06) 100%
    );
}

.case-hero__content {
  position: relative;
  z-index: 1;
}

.case-card {
  max-width: 720px;
}

.case-card__tag {
  margin: 0 0 12px;
  display: inline-flex;
  width: fit-content;
  padding: 6px 14px;
  border-radius: 100px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  color: var(--primary);
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(22, 119, 255, 0.22);
}

.case-card__title {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 600;
  color: var(--primary-dark);
  letter-spacing: -0.02em;
  text-shadow: 0 1px 16px rgba(255, 255, 255, 0.9);
}

.case-card__desc {
  margin: 16px 0 0;
  font-size: 0.95rem;
  line-height: 1.85;
  color: #334155;
  text-shadow: 0 1px 10px rgba(255, 255, 255, 0.75);
}

.case-carousel /deep/ .slick-dots {
  bottom: 24px;
}

.case-carousel /deep/ .slick-dots li button {
  background: rgba(22, 119, 255, 0.28);
  border-radius: 99px;
}

.case-carousel /deep/ .slick-dots li.slick-active button {
  background: var(--primary);
}

.case-list-section {
  padding-top: 72px;
}

.case-list__title {
  margin: 0 0 36px;
  font-size: clamp(1.5rem, 3vw, 1.875rem);
  font-weight: 600;
  color: var(--text);
  letter-spacing: -0.02em;
}

.case-list-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 24px;
}

.case-list-card {
  display: flex;
  flex-direction: column;
  background: var(--bg);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06);
  transition: transform 0.3s, box-shadow 0.3s;
}

.case-list-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.1);
}

.case-list-card__media {
  position: relative;
  aspect-ratio: 16 / 10;
  overflow: hidden;
}

.case-list-card__cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.case-list-card__stock {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 6px 10px;
  font-size: 0.72rem;
  line-height: 1.2;
  color: #fff;
  background: rgba(15, 23, 42, 0.62);
}

.case-list-card__body {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 18px 18px 16px;
}

.case-list-card__brand {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.case-list-card__logo {
  width: auto;
  height: 32px;
  max-width: 140px;
  object-fit: contain;
  object-position: left center;
  flex-shrink: 0;
}

.case-list-card__name {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text);
}

.case-list-card__headline {
  flex: 1;
  margin: 0 0 16px;
  font-size: 0.875rem;
  line-height: 1.65;
  color: #64748b;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.case-list-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: auto;
}

.case-list-card__tag {
  display: inline-flex;
  padding: 4px 10px;
  font-size: 0.75rem;
  color: #64748b;
  background: #f1f5f9;
  border-radius: 4px;
}

.case-list-card__link {
  flex-shrink: 0;
  font-size: 0.8125rem;
  color: #475569;
  transition: color 0.2s;
}

.case-list-card__link:hover {
  color: var(--primary);
}

@media (prefers-reduced-motion: reduce) {
  .case-list-card:hover {
    transform: none;
  }
}

@media (max-width: 991px) {
  .case-list-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
  }

  .case-hero {
    min-height: 520px;
    padding: 56px 0 80px;
  }

  .case-card {
    max-width: 100%;
  }

  .case-card__title {
    font-size: 1.35rem;
  }

  .case-card__desc {
    margin-top: 12px;
    font-size: 0.875rem;
  }
}

@media (max-width: 575px) {
  .case-list-grid {
    grid-template-columns: 1fr;
  }

  .case-list-section {
    padding-top: 56px;
  }
}
</style>
